// src/task/TaskBoardWrapper.js
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import TaskBoard from './TaskBoard';
import './bord.css';

const TaskBoardWrapper = () => {
  const { tasks, setTasks, allTasks, searchTerm } = useOutletContext();
  return <TaskBoard tasks={searchTerm ? allTasks : tasks} setTasks={setTasks} />;
};

export default TaskBoardWrapper;
